import { axiosInstance } from "./api";

/**
 * Get survey by project Id.
 * @param projectId - projectID
 * @returns any
 */
export async function apiGetSurvey(
  projectId,
) {
  const response = await axiosInstance.get(
    `/survey/byMasterProject/${projectId}`,
  );
  return response.data ?? null;
}

/**
 * Get 2 random results.
 * @param projectId - projectID
 * @returns any
 */
export async function apiGetRandomResults(
  projectId,
) {
  const response = await axiosInstance.get(
    `/survey/randomMaster/${projectId}`,
  );
  return response.data ?? null;
}
